//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';

// import api from '@/api/student'
export default {
  components: {},
  name: 'proposal-wrap',
  data() {
    return {
      text: '',
      picList: [],
      picArr: []
    };
  },
  methods: {
    ...mapActions(['getDistrict', 'AgettabberSwite']),
    addPic(e) {
      let that = this;
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        let url = e.target.result;
        let obj = { url: url };
        let params = {
          name: 'portrait',
          type: url.substring(url.indexOf(':') + 1, url.indexOf(';')),
          content: url.substring(url.indexOf(',') + 1)
        };
        if (that.picList.length < 3) {
          that.picList.push(obj);

          // that.picArr.push(json.data.description);
        } else {
          that.picList.splice(2, 1);
          that.picList.push(obj);

          that.picArr.splice(2, 1);
          // that.picArr.push(json.data.description);
        }
        // api.uploadFile(params).then(json=>{
        //     if(json.data.code === 1){
        //       if (that.picList.length < 3) {
        //         that.picList.push(obj)

        //         that.picArr.push(json.data.description);
        //       } else {
        //         that.picList.splice(2, 1)
        //         that.picList.push(obj)

        //         that.picArr.splice(2, 1)
        //         that.picArr.push(json.data.description);
        //       }
        //     }
        // })
      };
    },
    changePic(e, index) {
      let that = this;
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        let url = e.target.result;
        let obj = { url: url };
        let params = {
          name: 'portrait',
          type: url.substring(url.indexOf(':') + 1, url.indexOf(';')),
          content: url.substring(url.indexOf(',') + 1)
        };
        // api.uploadFile(params).then(json=>{
        //     if(json.data.code === 1){
        //        that.picList.splice(index, 1, obj)
        //        that.picArr.splice(index, 1, json.data.description);
        //   }
        // })
      };
    },
    removeFile(index) {
      this.picList.splice(index, 1);
      this.picArr.splice(index, 1);
    },
    feedback() {
      let params = {
        content: this.text,
        picture: this.picArr
      };
      // api.feedback(params).then(json => {
      //   alert('提交成功!')
      //   window.location.href = '#/personal?navName=我的&tabSwite=0'
      // })
    }
  },
  watch: {
    allNumber(newVal) {},
    picList(newVal) {}
  },
  computed: {
    ...mapGetters(['allNumber'])
  },
  created() {},
  mounted() {
    let elem = document.querySelector('#vux_view_box_body');
    setTimeout(() => {
      elem.style.paddingBottom = '0';
    }, 10);
  }
};
